import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class ZeasnNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    console.log('[NetworkStatus] checking Zeasn...');
    return this.onlineByAjax();
  }

}

export default ZeasnNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/zeasn/NetworkStatus.js